import React, { FC } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { globalTheme } from '@cld/component-theme';
import { useOptions } from '../../../../selectors';
import { selectDefaultTransformations } from '../../../../actions';
import { TransformationItem } from './TransformationItem';

const TransformationListRoot = styled.div`
  display: flex;
  padding-bottom: ${globalTheme.spacing.sm};
  flex-wrap: wrap;
`;

export const TransformationsList: FC = () => {
  const { transformations } = useOptions();
  const dispatch = useDispatch();

  const handleOnItemClick = ({ key, value }: { key: string; value: boolean }) => {
    dispatch(selectDefaultTransformations({ key, value }));
  };

  return (
    <TransformationListRoot data-test="transformations-container">
      {transformations?.map((item) => (
        <TransformationItem item={item} key={item.key} onClick={handleOnItemClick} />
      ))}
    </TransformationListRoot>
  );
};
